import React, { useState } from "react";
import "./Milestonerewards.scss";
import { data, termCondition } from "../data/MileStoneData";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Button from "./Buttons/Button";
const Milestonerewards = ({ categoryId, title = "", description = "" }) => {
  const [tcModal, setTcModal] = useState(false);
  const toggleTcModal = () => setTcModal(!tcModal);
  let titleText;
  switch (categoryId) {
    case "65524e633c005ef3b51907c9":
      titleText = "Assignment Help";
      break;
    case "65524e353c005ef3b51907c2":
      titleText = "Live Session Help";
      break;
    case "65524e5e3c005ef3b51907c6":
      titleText = "Homework Help";
      break;
  }

  if(!data?.length){
    return null;
  }
  return (
      <section className="first-section-ref mt-5">
        <div className="container">
          <div>
            <h1 className="heading-content text-center mb-2">
             {title || `Earn Rewards with Every ${titleText} Milestone`}
            </h1>
               <div className="description">
                {description || "Designed to deliver quality, accuracy, and convenience for every studen"}
               </div>
          </div>
          <div className="row">
            {data &&
              data?.length > 0 &&
              data.map((item, index) => {
                return (
                  <div className="col-6 col-lg-4 col-md-6 mb-4" key={index}>
                    <div className="card-box-re border-0 rounded-4">
                      <div className="card-area">
                        <h5 className="card-title-rw">{item.title}</h5>
                        <hr className="w-50 mx-auto" />
                        <div className="d-flex flex-column align-items-end">
                          <img
                            src={item.image}
                            className="assignment-image-row-1"
                            alt={item.title}
                          />
                        </div>
                        <div className="box-dis">
                          <span className="text-1">{item.description}</span>
                          <br />
                          <span className="text-2">{item.next}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="container mt-4 mb-3">
            <div className="text-center mt-4">
              <Button
                varient="primary"
                text=" Terms & Conditions"
                onClick={toggleTcModal}
              />
            </div>

            <Modal isOpen={tcModal} toggle={toggleTcModal} centered size="lg"  >
              <ModalHeader toggle={toggleTcModal} style={{ padding: "1.5rem 2rem" }}>
               <h1> Terms & Conditions</h1>
              </ModalHeader>

              <ModalBody style={{ padding: "2em 2rem" }}>
                <ul className="line-space">
                  {termCondition &&
                    termCondition.length > 0 &&
                    termCondition.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                </ul>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </section>
  );
};

export default Milestonerewards;
